import { Component, inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-validation-endpoint-modal',
  templateUrl: './validation-endpoint-modal.component.html',
  styleUrls: ['./validation-endpoint-modal.component.scss'],
  standalone: false
})
export class ValidationEndpointModalComponent {
  public data = inject(NZ_MODAL_DATA) as { message: string };

  constructor(
    private dialogRef: NzModalRef<ValidationEndpointModalComponent>
  ) { }


  onCancel(): void {
    this.dialogRef.close(false);
  }

  onAccept(): void {
    this.dialogRef.close(true);
  }
}
